import { render, staticRenderFns } from "./RdCustomerSelector.vue?vue&type=template&id=5f26e161&scoped=true&"
import script from "./RdCustomerSelector.vue?vue&type=script&lang=ts&"
export * from "./RdCustomerSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26e161",
  null
  
)

export default component.exports